import { defineStore } from 'pinia'
import type { FeatureFlag } from '~/utils/isFeatureEnabled'
import { HomeApi } from '~/features/Home/api/homeApi'

export const useMainStore = defineStore('main', () => {
  const featureFlags = ref<FeatureFlag>({})

  async function getFeatureFlags() {
    try {
      featureFlags.value = await HomeApi.getFeatureFlags()
    } catch (e) {
      showError(e)
    }
  }

  return {
    featureFlags,
    getFeatureFlags,
  }
})
